query SentenceGroupsLightQuery($mine: Boolean!) {
  sentenceGroups(mine: $mine) {
    reading {
      id
      description
      user {
        username
      }
    }
    category {
      id
      description
      order
    }
  }
}
